<template>
    <div class="row">
        <div class="col-md-6">
            <csp-form-group-select-insurance-policy-parent
                :insurance-policy-form="insurancePolicyForm"
                property="parentInsuranceId" :required="!isDeliveryClaim"/>
        </div>

        <!-- Force next columns to break to new line -->
        <div class="w-100"/>

        <div class="col-md-6">
            <csp-form-group-input :form="insurancePolicyForm" label-property="policyholderInsuranceReference"
                property="adversaryInsuranceReference"/>
        </div>

        <div class="col-md-6">
            <csp-form-group-input :form="insurancePolicyForm" property="insurancePolicyNr"/>
        </div>

        <!-- Force next columns to break to new line -->
        <div class="w-100"/>

        <div class="col-md-6">
            <csp-form-group-optional-bool :form="insurancePolicyForm" :label-cols="6"
                property="partialCoverage" type="text"/>
            <csp-form-group-input v-if="isPartialCoverageYesSelected" :form="insurancePolicyForm"
                property="partialCoverageCopayment"/>
        </div>

        <div class="col-md-6">
            <csp-form-group-optional-bool :form="insurancePolicyForm" :label-cols="6"
                property="comprehensive" type="text"/>
            <csp-form-group-input v-if="isComprehensiveYesSelected" :form="insurancePolicyForm"
                property="comprehensiveCopayment"/>
        </div>
    </div>
</template>

<script>
    import Form from '@form/Form';

    export default {
        props: {
            insurancePolicyForm: {
                type: Form,
                required: true,
            },
            isDeliveryClaim: {
                type: Boolean,
                required: false,
                default: false,
            },
            isFirstPartyDamage: {
                type: Boolean,
                required: false,
                default: false,
            },
            selectedFirm: {
                type: Object,
                required: false,
                default: null,
            },
        },
        computed: {
            isPartialCoverageYesSelected() {
                return this.insurancePolicyForm.getDataOfProperty('partialCoverage') === 'yes';
            },
            isComprehensiveYesSelected() {
                return this.insurancePolicyForm.getDataOfProperty('comprehensive') === 'yes';
            },
        },
        mounted() {
            if (this.isFirstPartyDamage && this.selectedFirm && this.selectedFirm.insuranceNumber) {
                this.insurancePolicyForm.setProperty('insurancePolicyNr', this.selectedFirm.insuranceNumber);
            }
        },
    }
</script>
